/* CRAFTD pack picker behaviour.
 *
 * WHAT WENT WRONG BEFORE, so it is not repeated. The previous version painted
 * the row prices and then wrote the cart state at the END of the same
 * function, behind an early `if (!d) return`. Any time Alpine was not ready,
 * the rows looked right and the cart was untouched: Danny selected 2 chains,
 * added to cart, and got one Cuban at 48.74. Paint and cart state are now
 * separate jobs, and the cart state is ALSO written in a capture-phase submit
 * listener on the form, so whatever happened during the page's life the
 * payload is correct at the moment the button is pressed. If Alpine is
 * unreachable even then, this file does the add itself rather than letting a
 * wrong line through.
 *
 * THE ARITHMETIC (Danny, 1 Sep 2026): ncCM3 is the point. Where a saving
 * exists it comes off the SECOND chain, not off the pair, and it must match
 * a live automatic discount:
 *
 *   scope "second"  (chains) the live discount is a Buy 1 Get 1 15% BXGY
 *                   that Shopify applies to the CHEAPEST eligible chain, so
 *                   the painted cut is r2% of min(hero, second chain). Row 3
 *                   adds the bracelet at full price, same cut.
 *   scope "pack"    (bracelets, rings) the live 2+/3+ collection discounts,
 *                   r2/r3% off the whole pack.
 *   r2 = 0          (pendants, caps) plain totals, no claim anywhere.
 *
 * HOW IT TALKS TO THE PRODUCT FORM. Two shapes exist across the stores:
 *
 *   WITH the croPack contract (UK): the form's Alpine data carries
 *   { croPack, packPrice, croChainId } and the ATC label reads
 *   croPack === 2 && packPrice ? packPrice : price. croPack is a FLAG, 2 for
 *   any multi row; the real count lives here.
 *
 *   WITHOUT it (EU, US - their product-detail.liquid predates the contract):
 *   the label reads price + croAddonPrices[each addon], so this file writes
 *   the DISCOUNTED price of the pieces it adds into window.croAddonPrices
 *   and the button lands on the pack total through the section's own math.
 *
 * Either way the extra pieces ride in the form-level addons array and the
 * form posts one line per id. window.croPackSetVariants stays an empty array
 * so the UK section's set-swap branch on variant-updated never fires.
 *
 * Only ids this file added are ever removed from addons. The upsells in
 * product-addons.liquid write to the same array and must survive.
 */
(function () {
  'use strict';
  if (window.croPackBooted) return;
  window.croPackBooted = true;

  window.croPackSetVariants = [];

  function dataOf(el) {
    if (!el) return null;
    if (window.Alpine && window.Alpine.$data) {
      try { return window.Alpine.$data(el); } catch (e) {}
    }
    if (el._x_dataStack && el._x_dataStack[0]) return el._x_dataStack[0];
    if (el.__x && el.__x.$data) return el.__x.$data;
    return null;
  }

  function num(el, attr) { return parseInt((el && el.getAttribute(attr)) || '0', 10) || 0; }
  function attr(el, a) { return (el && el.getAttribute(a)) || ''; }
  function money(pence, symbol) { return (symbol || '£') + (pence / 100).toFixed(2); }

  /* ------------------------------------------------------------------ */

  function Pack(root) {
    this.root = root;
    this.form = root.closest('form');
    this.scope = attr(root, 'data-scope') || 'pack';
    /* the Liquid symbol derivation (0 | money | replace '0.00') fails on
       stores whose money format uses comma decimals (EU renders "€0,00"),
       so strip any digits and separators that survived */
    this.sym = (attr(root, 'data-symbol') || '£').replace(/[\d.,\s]/g, '') || '£';
    this.r2 = num(root, 'data-rate2') / 100;
    this.r3 = num(root, 'data-rate3') / 100;
    this.qty = 1;      /* row 1 is the default; see start() */
    this.mine = [];    /* addon ids this file put there */
    this.chainId = 0;
    this.contract = undefined;  /* does the form know croPack/packPrice? */
  }

  Pack.prototype.data = function () { return dataOf(this.form); };

  Pack.prototype.basePrice = function () {
    var d = this.data();
    if (d && typeof d.price === 'number' && d.price > 0) return d.price;
    return num(this.root, 'data-base-price');
  };

  Pack.prototype.tileIn = function (g) {
    var box = this.root.querySelector('[data-tiles="' + g + '"]');
    return box ? box.querySelector('.cro-tile.is-on') : null;
  };
  Pack.prototype.tilePrice = function (g) { return num(this.tileIn(g), 'data-price'); };
  Pack.prototype.tileVariant = function (g) { return num(this.tileIn(g), 'data-variant'); };

  Pack.prototype.totals = function () {
    var base = this.basePrice();
    var a = this.tilePrice('a');
    var b = this.tilePrice('b');
    var c = this.tilePrice('c');
    if (this.scope === 'second') {
      /* the BXGY discounts one piece per order, the cheapest eligible.
         Shopify truncates the pence (15% of 55.12 = 8.268 -> 8.26), so floor,
         not round, or the button sits 1p under the cart */
      var cutA = Math.floor(Math.min(base, a || base) * this.r2);
      var cutB = Math.floor(Math.min(base, b || base) * this.r2);
      return {
        1: { now: base, was: 0 },
        2: { now: base + a - (a ? cutA : 0), was: base + a },
        3: { now: base + b + c - (b ? cutB : 0), was: base + b + c }
      };
    }
    var was2 = base + a;
    var was3 = base + b + c;
    return {
      1: { now: base, was: 0 },
      2: { now: Math.round(was2 * (1 - this.r2)), was: was2 },
      3: { now: Math.round(was3 * (1 - this.r3)), was: was3 }
    };
  };

  /* Pure DOM. Never bails, never touches the cart. The rows carry
     server-rendered prices, so this only keeps them honest as the shopper
     changes length or swaps a piece. */
  Pack.prototype.paint = function () {
    var t = this.totals(), self = this;
    [1, 2, 3].forEach(function (n) {
      var now = self.root.querySelector('[data-pack-now="' + n + '"]');
      var was = self.root.querySelector('[data-pack-was="' + n + '"]');
      if (now) now.textContent = money(t[n].now, self.sym);
      if (was) was.textContent = t[n].was > t[n].now ? money(t[n].was, self.sym) : '';
    });
    ['a', 'b', 'c'].forEach(function (g) {
      var label = self.root.querySelector('[data-pick-name="' + g + '"]');
      var tile = self.tileIn(g);
      if (label) label.textContent = tile ? attr(tile, 'data-title') : '';
    });
  };

  /* Everything the form has to be holding for the chosen row. Called on every
     change AND again in the capture phase of submit. Returns false when
     Alpine could not be reached, so the caller can fall back. */
  Pack.prototype.sync = function () {
    var d = this.data();
    if (!d) return false;

    /* UK's section carries croPack/packPrice/croChainId and prices the button
       from them. The EU and US sections predate that contract, so there the
       button reads price + croAddonPrices[each addon] instead, and this file
       feeds that map the DISCOUNTED price of the pieces it adds. Detect once,
       before this file has added any properties of its own. */
    if (this.contract === undefined) {
      try { this.contract = ('croPack' in d); } catch (e) { this.contract = false; }
    }

    if (this.contract) {
      if (typeof d.croChainId === 'number' && d.croChainId > 0) this.chainId = d.croChainId;
      else if (!this.chainId && typeof d.id === 'number') this.chainId = d.id;
    }

    var t = this.totals();
    var extras = [];
    if (this.qty === 2) { var a = this.tileVariant('a'); if (a) extras.push(a); }
    if (this.qty === 3) {
      var b = this.tileVariant('b'); if (b) extras.push(b);
      var c = this.tileVariant('c'); if (c) extras.push(c);
    }

    if (!this.contract) {
      window.croAddonPrices = window.croAddonPrices || {};
      var map = window.croAddonPrices;
      var base = this.basePrice();
      this.mine.forEach(function (id) { delete map[id]; });
      if (this.qty === 2 && extras.length === 1) {
        map[extras[0]] = t[2].now - base;
      } else if (this.qty === 3 && extras.length === 2) {
        var cFull = this.tilePrice('c');
        map[extras[1]] = cFull;
        map[extras[0]] = t[3].now - base - cFull;
      }
    }

    var mine = this.mine;
    var kept = (d.addons || []).filter(function (id) { return mine.indexOf(id) === -1; });
    d.addons = kept.concat(extras);
    this.mine = extras.slice();

    if (this.contract) {
      if (this.chainId) d.id = this.chainId;
      d.croPack = this.qty > 1 ? 2 : 1;
      d.packPrice = this.qty > 1 ? t[this.qty].now : 0;
    }
    return true;
  };

  /* Alpine never arrived. Rather than let the form post a single line while
     the button says otherwise, do the add here. */
  Pack.prototype.ownAdd = function () {
    var h = this.form.querySelector('input[name="id"]');
    var items = [{ id: parseInt(h && h.value, 10), quantity: 1 }];
    if (this.qty === 2) { var a = this.tileVariant('a'); if (a) items.push({ id: a, quantity: 1 }); }
    if (this.qty === 3) {
      var b = this.tileVariant('b'); if (b) items.push({ id: b, quantity: 1 });
      var c = this.tileVariant('c'); if (c) items.push({ id: c, quantity: 1 });
    }
    items = items.filter(function (i) { return i.id; });
    if (!items.length) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        window.dispatchEvent(new CustomEvent('toggle-cart-drawer'));
      })
      .catch(function (e) { console.error('[cro-pack]', e); window.location.href = '/cart'; });
  };

  /* ---------------- rows and pickers ---------------- */

  Pack.prototype.movePickers = function () {
    var self = this;
    [2, 3].forEach(function (n) {
      var wrap = self.root.querySelector('[data-pickwrap="' + n + '"]');
      var slot = self.root.querySelector('[data-slot="' + n + '"]');
      if (!wrap) return;
      if (n === self.qty && slot) {
        slot.appendChild(wrap); wrap.hidden = false;
        /* the default piece is the cheapest, not the first, so it can sit off
           the right edge of the tile strip on a phone; bring it into view */
        wrap.querySelectorAll('.cro-tiles').forEach(function (strip) {
          var on = strip.querySelector('.cro-tile.is-on');
          if (on) strip.scrollLeft = Math.max(0, on.offsetLeft - strip.offsetLeft - 8);
        });
      }
      else { wrap.hidden = true; }
    });
  };

  Pack.prototype.setPack = function (n) {
    if (!this.root.querySelector('.cro-pack__row[data-pack="' + n + '"]')) n = 1;
    this.qty = n;
    this.root.querySelectorAll('.cro-pack__row').forEach(function (row) {
      var on = num(row, 'data-pack') === n;
      row.classList.toggle('is-on', on);
      var input = row.querySelector('input[type=radio]');
      if (input) input.checked = on;
    });
    this.movePickers();
    this.paint();
    this.sync();
  };

  Pack.prototype.onClick = function (e) {
    var eye = e.target.closest('[data-peek]');
    if (eye && this.root.contains(eye)) {
      e.preventDefault(); e.stopPropagation();
      this.openPeek(eye.closest('.cro-tile'));
      return;
    }
    if (e.target.closest('[data-peek-close]')) {
      e.preventDefault();
      e.target.closest('[data-peek-panel]').hidden = true;
      return;
    }
    var pickBtn = e.target.closest('[data-peek-pick]');
    if (pickBtn && this.root.contains(pickBtn)) {
      e.preventDefault();
      var panel = pickBtn.closest('[data-peek-panel]');
      var wanted = panel.getAttribute('data-for');
      var tiles = panel.closest('.cro-pick').querySelector('.cro-tiles');
      var match = tiles && tiles.querySelector('.cro-tile[data-variant="' + wanted + '"]');
      if (match) this.pickTile(match);
      panel.hidden = true;
      return;
    }
    var row = e.target.closest('.cro-pack__row');
    if (row && this.root.contains(row)) { this.setPack(num(row, 'data-pack')); return; }
    var tile = e.target.closest('.cro-tile');
    if (tile && this.root.contains(tile)) this.pickTile(tile);
  };

  Pack.prototype.pickTile = function (tile) {
    var group = tile.parentNode;
    [].forEach.call(group.children, function (t) { t.classList.remove('is-on'); });
    tile.classList.add('is-on');
    this.paint();
    this.sync();
  };

  Pack.prototype.openPeek = function (tile) {
    var pick = tile && tile.closest('.cro-pick');
    var panel = pick && pick.querySelector('[data-peek-panel]');
    if (!panel) return;
    var img = panel.querySelector('[data-peek-img]');
    var thumbs = panel.querySelector('[data-peek-thumbs]');
    var imgs = attr(tile, 'data-imgs').split('|').filter(Boolean);

    panel.querySelector('[data-peek-name]').textContent = attr(tile, 'data-title');
    panel.querySelector('[data-peek-price]').textContent = attr(tile, 'data-money');
    img.src = imgs[0] || '';
    img.alt = attr(tile, 'data-title');
    thumbs.innerHTML = '';
    if (imgs.length > 1) {
      imgs.forEach(function (src, i) {
        var b = document.createElement('button');
        b.type = 'button';
        if (i === 0) b.className = 'is-on';
        var im = document.createElement('img');
        im.src = src; im.alt = ''; im.loading = 'lazy';
        b.appendChild(im);
        b.addEventListener('click', function () {
          thumbs.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
          img.src = src;
        });
        thumbs.appendChild(b);
      });
    }
    panel.setAttribute('data-for', attr(tile, 'data-variant'));
    panel.hidden = false;
  };

  /* ---------------- boot ---------------- */

  Pack.prototype.start = function () {
    var self = this;

    this.root.addEventListener('click', function (e) { self.onClick(e); });
    this.root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var eye = e.target.closest && e.target.closest('[data-peek]');
      if (!eye || !self.root.contains(eye)) return;
      e.preventDefault(); e.stopPropagation();
      self.openPeek(eye.closest('.cro-tile'));
    });

    /* a length change reprices every row */
    window.addEventListener('variant-updated', function () {
      setTimeout(function () { self.paint(); self.sync(); }, 0);
    });

    /* THE FIX for the paint-only bug. Capture runs before the section's own
       @submit handler on the same element, so the payload is corrected at
       the last possible moment no matter what happened earlier. */
    this.form.addEventListener('submit', function (e) {
      if (self.sync()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      self.ownAdd();
    }, true);

    /* on caps both row-3 slots draw from the same collection, so they would
       open on the same piece; nudge the third slot to the next one along */
    var gb = this.root.querySelector('[data-tiles="b"]');
    var gc = this.root.querySelector('[data-tiles="c"]');
    if (gb && gc && gc.children.length > 1) {
      var onB = gb.querySelector('.cro-tile.is-on');
      var onC = gc.querySelector('.cro-tile.is-on');
      if (onB && onC && attr(onB, 'data-variant') === attr(onC, 'data-variant')) {
        onC.classList.remove('is-on');
        gc.children[1].classList.add('is-on');
      }
    }

    /* Row 1 on load (Danny, 1 Sep 2026, evening): open on the single piece
       at its own price, with rows 2 and 3 underneath as the offer. Liquid
       renders row 1 checked, so this matches the first paint. */
    this.setPack(1);

    /* Alpine may not have hydrated yet; keep trying so the first sync lands
       on real data. The submit listener above covers us either way. */
    var tries = 0;
    (function wait() {
      if (self.sync() || tries > 60) { self.paint(); return; }
      tries++;
      setTimeout(wait, 50);
    })();
  };

  /* the UK section's Alpine init() calls this with the checked row */
  window.croPackGo = function (n) {
    if (!window.croPackInstance) return;
    n = parseInt(n, 10);
    if (n !== 1 && n !== 2 && n !== 3) n = 1;
    window.croPackInstance.setPack(n);
  };

  function boot() {
    var roots = document.querySelectorAll('[data-cro-pack]');
    if (!roots.length) return;
    [].forEach.call(roots, function (root) {
      if (!root.closest('form')) return;
      var p = new Pack(root);
      if (!window.croPackInstance) window.croPackInstance = p;
      p.start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
